import type { AspidaClient } from "aspida";
import { dataToURLString } from "aspida";
import type { Methods as Methods0 } from "./banner_setting";
import type { Methods as Methods1 } from "./category";
import type { Methods as Methods2 } from "./category/_idOrSlug@string";
import type { Methods as Methods3 } from "./contact_details";
import type { Methods as Methods4 } from "./contents";
import type { Methods as Methods5 } from "./contents/_idOrSlug@string";
import type { Methods as Methods6 } from "./contents/fixed/_idOrslug@string";
import type { Methods as Methods7 } from "./contents/preview/_key@string";
import type { Methods as Methods8 } from "./event_required";
import type { Methods as Methods9 } from "./events/_id@number";
import type { Methods as Methods10 } from "./events/preview/_key@string";
import type { Methods as Methods11 } from "./likes";
import type { Methods as Methods12 } from "./member/accesslog";
import type { Methods as Methods13 } from "./member/detail";
import type { Methods as Methods14 } from "./member/link_user_line_account";
import type { Methods as Methods15 } from "./member/register";
import type { Methods as Methods16 } from "./member/register/_id@string/_datetime_hash@string";
import type { Methods as Methods17 } from "./member/register/status";
import type { Methods as Methods18 } from "./member/identification_send";
import type { Methods as Methods19 } from "./member/update";
import type { Methods as Methods20 } from "./member_registration_form_setting";
import type { Methods as Methods21 } from "./menu_setting";
import type { Methods as Methods22 } from "./message_setting";
import type { Methods as Methods23 } from "./password/reset/_id@string/_datetime_hash@string";
import type { Methods as Methods24 } from "./password/reset-mail";
import type { Methods as Methods25 } from "./password/update";
import type { Methods as Methods26 } from "./point/autogrant";
import type { Methods as Methods27 } from "./point/history";
import type { Methods as Methods28 } from "./point/request";
import type { Methods as Methods29 } from "./popup_setting";
import type { Methods as Methods30 } from "./reservation_settings";
import type { Methods as Methods31 } from "./reservations";
import type { Methods as Methods32 } from "./site";
import type { Methods as Methods33 } from "./tracking";
import type { Methods as Methods34 } from "./ranks";
import type { Methods as Methods35 } from "./member/identification/_id@string/_datetime_hash@string";
import type { Methods as Methods36 } from "./chat_config";
import type { Methods as Methods37 } from "./mail_message";
import type { Methods as Methods38 } from "./survey_forms/_id@string";
import type { Methods as Methods39 } from "./survey_forms/_id@string/answers";
import type { Methods as Methods40 } from "./bookmarks";
import type { Methods as Methods41 } from "./push_notification/update_device";
import type { Methods as Methods42 } from "./push_notification/settings";
import type { Methods as Methods43 } from "./push_notification/push_member";
import type { Methods as Methods44 } from "./board";
import type { Methods as Methods45 } from "./board_category";
import type { Methods as Methods46 } from "./image";
import type { Methods as Methods47 } from "./ng_words";
import type { Methods as Methods48 } from "./board_likes";
import type { Methods as Methods49 } from "./board_view";
import type { Methods as Methods50 } from './board_report';
import type { Methods as Methods51 } from './board_comment';
import type { Methods as Methods52 } from './comment_report';
import type { Methods as Methods53 } from './pinned_comment';
import type { Methods as Methods54 } from './notification';
import type { Methods as Methods55 } from './board_categories_page';
import type { Methods as Methods56 } from "./board_category/_id@number";
import type { Methods as Methods57 } from "./board_category/_id@number/boards";
import type { Methods as Methods58 } from "./member/update_icon_nickname";

const api = <T,>({ baseURL, fetch }: AspidaClient<T>) => {
  const prefix = (baseURL === undefined ? "" : baseURL).replace(/\/$/, "");
  const PATH0 = "/banner_setting";
  const PATH1 = "/category";
  const PATH2 = "/contact_details";
  const PATH3 = "/contents";
  const PATH4 = "/contents/fixed";
  const PATH5 = "/contents/preview";
  const PATH6 = "/event_required";
  const PATH7 = "/events";
  const PATH8 = "/events/preview";
  const PATH9 = "/likes";
  const PATH10 = "/member/accesslog";
  const PATH11 = "/member/detail";
  const PATH12 = "/member/link_user_line_account";
  const PATH13 = "/member/register";
  const PATH14 = "/member/register/status";
  const PATH15 = "/member/identification_send";
  const PATH16 = "/member/update";
  const PATH17 = "/member_registration_form_setting";
  const PATH18 = "/menu_setting";
  const PATH19 = "/message_setting";
  const PATH20 = "/password/reset";
  const PATH21 = "/password/reset-mail";
  const PATH22 = "/password/update";
  const PATH23 = "/point/autogrant";
  const PATH24 = "/point/history";
  const PATH25 = "/point/request";
  const PATH26 = "/popup_setting";
  const PATH27 = "/reservation_settings";
  const PATH28 = "/reservations";
  const PATH29 = "/site";
  const PATH30 = "/tracking";
  const PATH31 = "/ranks";
  const PATH32 = "/site/preview";
  const PATH33 = "/member/identification";
  const PATH34 = "/chat_config";
  const PATH35 = "/mail/message";
  const PATH36 = "/survey_forms";
  const PATH37 = "/bookmarks";
  const PATH38 = "/notification/update_device";
  const PATH39 = "/notification/settings";
  const PATH40 = "/notification/push_member";
  const PATH41 = "/boards";
  const PATH42 = "/board_categories";
  const PATH43 = "/images";
  const PATH44 = "/ng_words";
  const PATH45 = "/board_likes/information";
  const PATH46 = "/boards/report";
  const PATH47 = "/board_likes";
  const PATH48 = "/board_view";
  const PATH49 = "/board_comment";
  const PATH50 = "/board_comment/report";
  const PATH51 = "/board_comment/update_pinned_status";
  const PATH52 = "/boards/recent";
  const PATH53 = "/notifications";
  const PATH54 = "/notifications/mark_as_read";
  const PATH55 = "/board_categories/get_all_categories_forum_page"
  const PATH56 = "/boards/my_boards";
  const PATH57 = "/boards/my_activity_boards";
  const PATH58 = "/board_comment/my_comments";
  const PATH59 = "/boards/edit";
  const PATH60 = "/member/update_member_icon_nickname"

  const GET = "GET";
  const POST = "POST";
  const PUT = "PUT";
  const DELETE = "DELETE";

  return {
    banner_setting: {
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<Methods0["get"]["resBody"]>(prefix, PATH0, GET, option).json(),
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<Methods0["get"]["resBody"]>(prefix, PATH0, GET, option)
          .json()
          .then((r) => r.body),
      $path: () => `${prefix}${PATH0}`,
    },
    category: {
      _idOrSlug: (val1: string) => {
        const prefix1 = `${PATH1}/${val1}`;

        return {
          get: (option: {
            headers: Methods2["get"]["reqHeaders"];
            config?: T | undefined;
          }) =>
            fetch<Methods2["get"]["resBody"]>(
              prefix,
              prefix1,
              GET,
              option
            ).json(),
          $get: (option: {
            headers: Methods2["get"]["reqHeaders"];
            config?: T | undefined;
          }) =>
            fetch<Methods2["get"]["resBody"]>(prefix, prefix1, GET, option)
              .json()
              .then((r) => r.body),
          $path: () => `${prefix}${prefix1}`,
        };
      },
      get: (option: {
        query?: Methods1["get"]["query"] | undefined;
        headers: Methods1["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods1["get"]["resBody"]>(prefix, PATH1, GET, option).json(),
      $get: (option: {
        query?: Methods1["get"]["query"] | undefined;
        headers: Methods1["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods1["get"]["resBody"]>(prefix, PATH1, GET, option)
          .json()
          .then((r) => r.body),
      $path: (
        option?:
          | { method?: "get" | undefined; query: Methods1["get"]["query"] }
          | undefined
      ) =>
        `${prefix}${PATH1}${
          option && option.query ? `?${dataToURLString(option.query)}` : ""
        }`,
    },
    contact_details: {
      post: (option: {
        body: Methods3["post"]["reqBody"];
        headers?: Methods3["post"]["reqHeaders"] | undefined;
        config?: T | undefined;
      }) =>
        fetch<Methods3["post"]["resBody"]>(prefix, PATH2, POST, option).json(),
      $post: (option: {
        body: Methods3["post"]["reqBody"];
        headers?: Methods3["post"]["reqHeaders"] | undefined;
        config?: T | undefined;
      }) =>
        fetch<Methods3["post"]["resBody"]>(prefix, PATH2, POST, option)
          .json()
          .then((r) => r.body),
      $path: () => `${prefix}${PATH2}`,
    },
    contents: {
      _idOrSlug: (val1: string) => {
        const prefix1 = `${PATH3}/${val1}`;

        return {
          get: (
            option?:
              | {
                  headers?: Methods5["get"]["reqHeaders"] | undefined;
                  config?: T | undefined;
                }
              | undefined
          ) =>
            fetch<Methods5["get"]["resBody"]>(
              prefix,
              prefix1,
              GET,
              option
            ).json(),
          $get: (
            option?:
              | {
                  headers?: Methods5["get"]["reqHeaders"] | undefined;
                  config?: T | undefined;
                }
              | undefined
          ) =>
            fetch<Methods5["get"]["resBody"]>(prefix, prefix1, GET, option)
              .json()
              .then((r) => r.body),
          $path: () => `${prefix}${prefix1}`,
        };
      },
      fixed: {
        _idOrslug: (val2: string) => {
          const prefix2 = `${PATH4}/${val2}`;

          return {
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods6["get"]["resBody"]>(
                prefix,
                prefix2,
                GET,
                option
              ).json(),
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods6["get"]["resBody"]>(prefix, prefix2, GET, option)
                .json()
                .then((r) => r.body),
            $path: () => `${prefix}${prefix2}`,
          };
        },
      },
      preview: {
        _key: (val2: string) => {
          const prefix2 = `${PATH5}/${val2}`;

          return {
            get: (
              option?:
                | {
                    headers?: Methods7["get"]["reqHeaders"] | undefined;
                    config?: T | undefined;
                  }
                | undefined
            ) =>
              fetch<Methods7["get"]["resBody"]>(
                prefix,
                prefix2,
                GET,
                option
              ).json(),
            $get: (
              option?:
                | {
                    headers?: Methods7["get"]["reqHeaders"] | undefined;
                    config?: T | undefined;
                  }
                | undefined
            ) =>
              fetch<Methods7["get"]["resBody"]>(prefix, prefix2, GET, option)
                .json()
                .then((r) => r.body),
            $path: () => `${prefix}${prefix2}`,
          };
        },
      },
      get: (
        option?:
          | {
              query?: Methods4["get"]["query"] | undefined;
              headers?: Methods4["get"]["reqHeaders"] | undefined;
              config?: T | undefined;
            }
          | undefined
      ) => fetch<Methods4["get"]["resBody"]>(prefix, PATH3, GET, option).json(),
      $get: (
        option?:
          | {
              query?: Methods4["get"]["query"] | undefined;
              headers?: Methods4["get"]["reqHeaders"] | undefined;
              config?: T | undefined;
            }
          | undefined
      ) =>
        fetch<Methods4["get"]["resBody"]>(prefix, PATH3, GET, option)
          .json()
          .then((r) => r.body),
      $path: (
        option?:
          | { method?: "get" | undefined; query: Methods4["get"]["query"] }
          | undefined
      ) =>
        `${prefix}${PATH3}${
          option && option.query ? `?${dataToURLString(option.query)}` : ""
        }`,
    },
    event_required: {
      get: (
        option?:
          | {
              query?: Methods8["get"]["query"] | undefined;
              config?: T | undefined;
            }
          | undefined
      ) => fetch<Methods8["get"]["resBody"]>(prefix, PATH6, GET, option).json(),
      $get: (
        option?:
          | {
              query?: Methods8["get"]["query"] | undefined;
              config?: T | undefined;
            }
          | undefined
      ) =>
        fetch<Methods8["get"]["resBody"]>(prefix, PATH6, GET, option)
          .json()
          .then((r) => r.body),
      $path: (
        option?:
          | { method?: "get" | undefined; query: Methods8["get"]["query"] }
          | undefined
      ) =>
        `${prefix}${PATH6}${
          option && option.query ? `?${dataToURLString(option.query)}` : ""
        }`,
    },
    events: {
      _id: (val1: number) => {
        const prefix1 = `${PATH7}/${val1}`;

        return {
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods9["get"]["resBody"]>(
              prefix,
              prefix1,
              GET,
              option
            ).json(),
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods9["get"]["resBody"]>(prefix, prefix1, GET, option)
              .json()
              .then((r) => r.body),
          $path: () => `${prefix}${prefix1}`,
        };
      },
      preview: {
        _key: (val2: string) => {
          const prefix2 = `${PATH8}/${val2}`;

          return {
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods10["get"]["resBody"]>(
                prefix,
                prefix2,
                GET,
                option
              ).json(),
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods10["get"]["resBody"]>(prefix, prefix2, GET, option)
                .json()
                .then((r) => r.body),
            $path: () => `${prefix}${prefix2}`,
          };
        },
      },
    },
    likes: {
      post: (option: {
        body: Methods11["post"]["reqBody"];
        headers: Methods11["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods11["post"]["resBody"]>(prefix, PATH9, POST, option).json(),
      $post: (option: {
        body: Methods11["post"]["reqBody"];
        headers: Methods11["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods11["post"]["resBody"]>(prefix, PATH9, POST, option)
          .json()
          .then((r) => r.body),
      get: (
        option?:
          | {
              query?: Methods11["get"]["query"] | undefined;
              headers?: Methods11["get"]["reqHeaders"] | undefined;
              config?: T | undefined;
            }
          | undefined
      ) =>
        fetch<Methods11["get"]["resBody"]>(prefix, PATH9, GET, option).json(),
      $get: (
        option?:
          | {
              query?: Methods11["get"]["query"] | undefined;
              headers?: Methods11["get"]["reqHeaders"] | undefined;
              config?: T | undefined;
            }
          | undefined
      ) =>
        fetch<Methods11["get"]["resBody"]>(prefix, PATH9, GET, option)
          .json()
          .then((r) => r.body),
      $path: (
        option?:
          | { method?: "get" | undefined; query: Methods40["get"]["query"] }
          | undefined
      ) =>
        `${prefix}${PATH9}${
          option && option.query ? `?${dataToURLString(option.query)}` : ""
        }`,
    },
    bookmarks: {
      post: (option: {
        body: Methods40["post"]["reqBody"];
        headers: Methods40["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods40["post"]["resBody"]>(
          prefix,
          PATH37,
          POST,
          option
        ).json(),
      $post: (option: {
        body: Methods40["post"]["reqBody"];
        headers: Methods40["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods40["post"]["resBody"]>(prefix, PATH37, POST, option)
          .json()
          .then((r) => r.body),
      get: (
        option?:
          | {
              query?: Methods40["get"]["query"] | undefined;
              headers?: Methods40["get"]["reqHeaders"] | undefined;
              config?: T | undefined;
            }
          | undefined
      ) =>
        fetch<Methods40["get"]["resBody"]>(prefix, PATH37, GET, option).json(),
      $get: (
        option?:
          | {
              query?: Methods40["get"]["query"] | undefined;
              headers?: Methods40["get"]["reqHeaders"] | undefined;
              config?: T | undefined;
            }
          | undefined
      ) =>
        fetch<Methods40["get"]["resBody"]>(prefix, PATH37, GET, option)
          .json()
          .then((r) => r.body),
      $path: (
        option?:
          | { method?: "get" | undefined; query: Methods40["get"]["query"] }
          | undefined
      ) =>
        `${prefix}${PATH37}${
          option && option.query ? `?${dataToURLString(option.query)}` : ""
        }`,
    },
    member: {
      accesslog: {
        post: (option: {
          body: Methods12["post"]["reqBody"];
          headers: Methods12["post"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods12["post"]["resBody"]>(
            prefix,
            PATH10,
            POST,
            option
          ).json(),
        $post: (option: {
          body: Methods12["post"]["reqBody"];
          headers: Methods12["post"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods12["post"]["resBody"]>(prefix, PATH10, POST, option)
            .json()
            .then((r) => r.body),
        $path: () => `${prefix}${PATH10}`,
      },
      detail: {
        get: (option: {
          headers: Methods13["get"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods13["get"]["resBody"]>(
            prefix,
            PATH11,
            GET,
            option
          ).json(),
        $get: (option: {
          headers: Methods13["get"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods13["get"]["resBody"]>(prefix, PATH11, GET, option)
            .json()
            .then((r) => r.body),
        $path: () => `${prefix}${PATH11}`,
      },
      link_user_line_account: {
        post: (option: {
          body: Methods14["post"]["reqBody"];
          headers: Methods14["post"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods14["post"]["resBody"]>(
            prefix,
            PATH12,
            POST,
            option
          ).json(),
        $post: (option: {
          body: Methods14["post"]["reqBody"];
          headers: Methods14["post"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods14["post"]["resBody"]>(prefix, PATH12, POST, option)
            .json()
            .then((r) => r.body),
        $path: () => `${prefix}${PATH12}`,
      },
      register: {
        _id: (val2: string) => {
          const prefix2 = `${PATH13}/${val2}`;

          return {
            _datetime_hash: (val3: string) => {
              const prefix3 = `${prefix2}/${val3}`;

              return {
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods16["get"]["resBody"]>(
                    prefix,
                    prefix3,
                    GET,
                    option
                  ).json(),
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods16["get"]["resBody"]>(
                    prefix,
                    prefix3,
                    GET,
                    option
                  )
                    .json()
                    .then((r) => r.body),
                $path: () => `${prefix}${prefix3}`,
              };
            },
          };
        },
        status: {
          post: (option: {
            body: Methods17["post"]["reqBody"];
            config?: T | undefined;
          }) =>
            fetch<Methods17["post"]["resBody"]>(
              prefix,
              PATH14,
              POST,
              option
            ).json(),
          $post: (option: {
            body: Methods17["post"]["reqBody"];
            config?: T | undefined;
          }) =>
            fetch<Methods17["post"]["resBody"]>(prefix, PATH14, POST, option)
              .json()
              .then((r) => r.body),
          $path: () => `${prefix}${PATH14}`,
        },
        post: (option: {
          body: Methods15["post"]["reqBody"];
          config?: T | undefined;
        }) =>
          fetch<Methods15["post"]["resBody"]>(
            prefix,
            PATH13,
            POST,
            option
          ).json(),
        $post: (option: {
          body: Methods15["post"]["reqBody"];
          config?: T | undefined;
        }) =>
          fetch<Methods15["post"]["resBody"]>(prefix, PATH13, POST, option)
            .json()
            .then((r) => r.body),
        $path: () => `${prefix}${PATH13}`,
      },
      identification_send: {
        post: (option: {
          body: Methods18["post"]["reqBody"];
          config?: T | undefined;
        }) =>
          fetch<Methods18["post"]["resBody"]>(
            prefix,
            PATH15,
            POST,
            option
          ).json(),
        $post: (option: {
          body: Methods18["post"]["reqBody"];
          config?: T | undefined;
        }) =>
          fetch<Methods18["post"]["resBody"]>(prefix, PATH15, POST, option)
            .json()
            .then((r) => r.body),
        $path: () => `${prefix}${PATH15}`,
      },
      update: {
        post: (option: {
          body: Methods19["post"]["reqBody"];
          headers: Methods19["post"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods19["post"]["resBody"]>(
            prefix,
            PATH16,
            POST,
            option
          ).json(),
        $post: (option: {
          body: Methods19["post"]["reqBody"];
          headers: Methods19["post"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods19["post"]["resBody"]>(prefix, PATH16, POST, option)
            .json()
            .then((r) => r.body),
        $path: () => `${prefix}${PATH16}`,
      },
      updateIconNickname: {
        post: (option: {
          body: Methods58["post"]["reqBody"];
          headers: Methods58["post"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods58["post"]["resBody"]>(
            prefix,
            PATH60,
            POST,
            option
          ).json(),
        $post: (option: {
          body: Methods58["post"]["reqBody"];
          headers: Methods58["post"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods58["post"]["resBody"]>(prefix, PATH60, POST, option)
            .json()
            .then((r) => r.body),
        $path: () => `${prefix}${PATH60}`,
      },
      identification: {
        _id: (val2: string) => {
          const prefix2 = `${PATH33}/${val2}`;

          return {
            _datetime_hash: (val3: string) => {
              const prefix3 = `${prefix2}/${val3}`;
              return {
                post: (
                  option?:
                    | {
                        body: Methods35["post"]["reqBody"];
                        config?: T | undefined;
                      }
                    | undefined
                ) =>
                  fetch<Methods35["post"]["resBody"]>(
                    prefix,
                    prefix3,
                    POST,
                    option
                  ).json(),
                $post: (
                  option?:
                    | {
                        body: Methods35["post"]["reqBody"];
                        config?: T | undefined;
                      }
                    | undefined
                ) =>
                  fetch<Methods35["post"]["resBody"]>(
                    prefix,
                    prefix3,
                    POST,
                    option
                  )
                    .json()
                    .then((r) => r.body),
                $path: () => `${prefix}${prefix3}`,
              };
            },
          };
        },
      },
    },
    member_registration_form_setting: {
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<Methods20["get"]["resBody"]>(prefix, PATH17, GET, option).json(),
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<Methods20["get"]["resBody"]>(prefix, PATH17, GET, option)
          .json()
          .then((r) => r.body),
      $path: () => `${prefix}${PATH17}`,
    },
    menu_setting: {
      get: (
        option?:
          | {
              query?: Methods21["get"]["query"] | undefined;
              config?: T | undefined;
            }
          | undefined
      ) =>
        fetch<Methods21["get"]["resBody"]>(prefix, PATH18, GET, option).json(),
      $get: (
        option?:
          | {
              query?: Methods21["get"]["query"] | undefined;
              config?: T | undefined;
            }
          | undefined
      ) =>
        fetch<Methods21["get"]["resBody"]>(prefix, PATH18, GET, option)
          .json()
          .then((r) => r.body),
      $path: (
        option?:
          | { method?: "get" | undefined; query: Methods21["get"]["query"] }
          | undefined
      ) =>
        `${prefix}${PATH18}${
          option && option.query ? `?${dataToURLString(option.query)}` : ""
        }`,
    },
    message_setting: {
      get: (
        option?:
          | {
              query?: Methods22["get"]["query"] | undefined;
              config?: T | undefined;
            }
          | undefined
      ) =>
        fetch<Methods22["get"]["resBody"]>(prefix, PATH19, GET, option).json(),
      $get: (
        option?:
          | {
              query?: Methods22["get"]["query"] | undefined;
              config?: T | undefined;
            }
          | undefined
      ) =>
        fetch<Methods22["get"]["resBody"]>(prefix, PATH19, GET, option)
          .json()
          .then((r) => r.body),
      $path: (
        option?:
          | { method?: "get" | undefined; query: Methods22["get"]["query"] }
          | undefined
      ) =>
        `${prefix}${PATH19}${
          option && option.query ? `?${dataToURLString(option.query)}` : ""
        }`,
    },
    password: {
      reset: {
        _id: (val2: string) => {
          const prefix2 = `${PATH20}/${val2}`;

          return {
            _datetime_hash: (val3: string) => {
              const prefix3 = `${prefix2}/${val3}`;

              return {
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods23["get"]["resBody"]>(
                    prefix,
                    prefix3,
                    GET,
                    option
                  ).json(),
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods23["get"]["resBody"]>(
                    prefix,
                    prefix3,
                    GET,
                    option
                  )
                    .json()
                    .then((r) => r.body),
                $path: () => `${prefix}${prefix3}`,
              };
            },
          };
        },
      },
      reset_mail: {
        post: (option: {
          body: Methods24["post"]["reqBody"];
          config?: T | undefined;
        }) =>
          fetch<Methods24["post"]["resBody"]>(
            prefix,
            PATH21,
            POST,
            option
          ).json(),
        $post: (option: {
          body: Methods24["post"]["reqBody"];
          config?: T | undefined;
        }) =>
          fetch<Methods24["post"]["resBody"]>(prefix, PATH21, POST, option)
            .json()
            .then((r) => r.body),
        $path: () => `${prefix}${PATH21}`,
      },
      update: {
        post: (option: {
          body: Methods25["post"]["reqBody"];
          config?: T | undefined;
        }) =>
          fetch<Methods25["post"]["resBody"]>(
            prefix,
            PATH22,
            POST,
            option
          ).json(),
        $post: (option: {
          body: Methods25["post"]["reqBody"];
          config?: T | undefined;
        }) =>
          fetch<Methods25["post"]["resBody"]>(prefix, PATH22, POST, option)
            .json()
            .then((r) => r.body),
        $path: () => `${prefix}${PATH22}`,
      },
    },
    point: {
      autogrant: {
        post: (option: {
          body: Methods26["post"]["reqBody"];
          headers: Methods26["post"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods26["post"]["resBody"]>(
            prefix,
            PATH23,
            POST,
            option
          ).json(),
        $post: (option: {
          body: Methods26["post"]["reqBody"];
          headers: Methods26["post"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods26["post"]["resBody"]>(prefix, PATH23, POST, option)
            .json()
            .then((r) => r.body),
        $path: () => `${prefix}${PATH23}`,
      },
      history: {
        get: (option: {
          query?: Methods27["get"]["query"] | undefined;
          headers: Methods27["get"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods27["get"]["resBody"]>(
            prefix,
            PATH24,
            GET,
            option
          ).json(),
        $get: (option: {
          query?: Methods27["get"]["query"] | undefined;
          headers: Methods27["get"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods27["get"]["resBody"]>(prefix, PATH24, GET, option)
            .json()
            .then((r) => r.body),
        $path: (
          option?:
            | { method?: "get" | undefined; query: Methods27["get"]["query"] }
            | undefined
        ) =>
          `${prefix}${PATH24}${
            option && option.query ? `?${dataToURLString(option.query)}` : ""
          }`,
      },
      request: {
        post: (option: {
          body: Methods28["post"]["reqBody"];
          headers: Methods28["post"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods28["post"]["resBody"]>(
            prefix,
            PATH25,
            POST,
            option
          ).json(),
        $post: (option: {
          body: Methods28["post"]["reqBody"];
          headers: Methods28["post"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods28["post"]["resBody"]>(prefix, PATH25, POST, option)
            .json()
            .then((r) => r.body),
        get: (option: {
          headers: Methods28["get"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods28["get"]["resBody"]>(
            prefix,
            PATH25,
            GET,
            option
          ).json(),
        $get: (option: {
          headers: Methods28["get"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods28["get"]["resBody"]>(prefix, PATH25, GET, option)
            .json()
            .then((r) => r.body),
        $path: () => `${prefix}${PATH25}`,
      },
    },
    popup_setting: {
      get: (option: {
        headers: Methods29["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods29["get"]["resBody"]>(prefix, PATH26, GET, option).json(),
      $get: (option: {
        headers: Methods29["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods29["get"]["resBody"]>(prefix, PATH26, GET, option)
          .json()
          .then((r) => r.body),
      $path: () => `${prefix}${PATH26}`,
    },
    reservation_settings: {
      get: (
        option?:
          | {
              query?: Methods30["get"]["query"] | undefined;
              config?: T | undefined;
            }
          | undefined
      ) =>
        fetch<Methods30["get"]["resBody"]>(prefix, PATH27, GET, option).json(),
      $get: (
        option?:
          | {
              query?: Methods30["get"]["query"] | undefined;
              config?: T | undefined;
            }
          | undefined
      ) =>
        fetch<Methods30["get"]["resBody"]>(prefix, PATH27, GET, option)
          .json()
          .then((r) => r.body),
      $path: (
        option?:
          | { method?: "get" | undefined; query: Methods30["get"]["query"] }
          | undefined
      ) =>
        `${prefix}${PATH27}${
          option && option.query ? `?${dataToURLString(option.query)}` : ""
        }`,
    },
    reservations: {
      post: (option: {
        body: Methods31["post"]["reqBody"];
        config?: T | undefined;
      }) =>
        fetch<Methods31["post"]["resBody"]>(
          prefix,
          PATH28,
          POST,
          option
        ).json(),
      $post: (option: {
        body: Methods31["post"]["reqBody"];
        config?: T | undefined;
      }) =>
        fetch<Methods31["post"]["resBody"]>(prefix, PATH28, POST, option)
          .json()
          .then((r) => r.body),
      $path: () => `${prefix}${PATH28}`,
    },
    site: {
      get: (option?: { config?: T | undefined } | undefined) =>
        fetch<Methods32["get"]["resBody"]>(prefix, PATH29, GET, option).json(),
      $get: (option?: { config?: T | undefined } | undefined) =>
        fetch<Methods32["get"]["resBody"]>(prefix, PATH29, GET, option)
          .json()
          .then((r) => r.body),
      $path: () => `${prefix}${PATH29}`,
      preview: {
        _key: (val2: string) => {
          const prefix2 = `${PATH32}/${val2}`;
          return {
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods32["get"]["resBody"]>(
                prefix,
                prefix2,
                GET,
                option
              ).json(),
          };
        },
      },
    },
    tracking: {
      post: (option: {
        body: Methods33["post"]["reqBody"];
        headers: Methods33["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods33["post"]["resBody"]>(
          prefix,
          PATH30,
          POST,
          option
        ).json(),
      $post: (option: {
        body: Methods33["post"]["reqBody"];
        headers: Methods33["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods33["post"]["resBody"]>(prefix, PATH30, POST, option)
          .json()
          .then((r) => r.body),
      $path: () => `${prefix}${PATH30}`,
    },
    ranks: {
      get: (option: {
        headers: Methods34["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods34["get"]["resBody"]>(prefix, PATH31, GET, option).json(),
      $get: (option: {
        headers: Methods34["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods34["get"]["resBody"]>(prefix, PATH31, GET, option)
          .json()
          .then((r) => r.body),
      $path: () => `${prefix}${PATH31}`,
    },
    chat_config: {
      get: (option: {
        headers: Methods36["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods36["get"]["resBody"]>(prefix, PATH34, GET, option).json(),
      $get: (option: {
        headers: Methods36["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods36["get"]["resBody"]>(prefix, PATH34, GET, option)
          .json()
          .then((r) => r.body),
      $path: () => `${prefix}${PATH34}`,
    },
    mail_message: {
      post: (option: {
        headers: Methods37["post"]["reqHeaders"];
        body: Methods37["post"]["reqBody"];
      }) =>
        fetch<Methods37["post"]["resBody"]>(
          prefix,
          PATH35,
          POST,
          option
        ).json(),
    },
    survey_forms: {
      _id: (val2: string) => {
        const prefix2 = `${PATH36}/${val2}`;
        const prefix3 = `${PATH36}/${val2}/survey_answers`;
        return {
          get: (
            option?:
              | {
                  config?: T | undefined;
                }
              | undefined
          ) =>
            fetch<Methods38["get"]["resBody"]>(
              prefix,
              prefix2,
              GET,
              option
            ).json(),
          $get: (
            option?:
              | {
                  config?: T | undefined;
                }
              | undefined
          ) =>
            fetch<Methods38["get"]["resBody"]>(prefix, prefix2, GET, option)
              .json()
              .then((r) => r.body),
          $path: () => `${prefix}${prefix2}`,
          post: (
            option?:
              | {
                  headers: Methods39["post"]["reqHeaders"];
                  body?: Methods39["post"]["reqBody"];
                  config?: T | undefined;
                }
              | undefined
          ) =>
            fetch<Methods39["post"]["resBody"]>(
              prefix,
              prefix3,
              POST,
              option
            ).json(),
          $post: (
            option?:
              | {
                  body?: Methods39["post"]["reqBody"];
                  config?: T | undefined;
                }
              | undefined
          ) =>
            fetch<Methods39["post"]["resBody"]>(prefix, prefix3, POST, option)
              .json()
              .then((r) => r.body),
        };
      },
    },
    notification_push_member: {
      post: (option: {
        body: Methods43["post"]["reqBody"];
        headers: Methods43["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods43["post"]["resBody"]>(
          prefix,
          PATH40,
          POST,
          option
        ).json(),
      $post: (option: {
        body: Methods43["post"]["reqBody"];
        headers: Methods43["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods43["post"]["resBody"]>(prefix, PATH40, POST, option)
          .json()
          .then((r) => r.body),
    },
    notification_update_device: {
      post: (option: {
        body: Methods41["post"]["reqBody"];
        headers: Methods41["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods41["post"]["resBody"]>(
          prefix,
          PATH38,
          POST,
          option
        ).json(),
      $post: (option: {
        body: Methods41["post"]["reqBody"];
        headers: Methods41["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods41["post"]["resBody"]>(prefix, PATH38, POST, option)
          .json()
          .then((r) => r.body),
    },
    notification_settings: {
      get: (option: {
        headers: Methods42["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods42["get"]["resBody"]>(prefix, PATH39, GET, option).json(),
      $get: (option: {
        headers: Methods42["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods42["get"]["resBody"]>(prefix, PATH39, GET, option)
          .json()
          .then((r) => r.body),
      $path: () => `${prefix}${PATH39}`,
    },
    board: {
      report: {
        put: (option: {
          query: Methods50["put"]["query"] | undefined;
          headers: Methods50["put"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods50["put"]["resBody"]>(
            prefix,
            PATH46,
            PUT,
            option
          ).json(),
        $put: (option: {
          query: Methods50["put"]["query"] | undefined;
          headers: Methods50["put"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods50["put"]["resBody"]>(prefix, PATH46, PUT, option)
            .json()
            .then((r) => r.body),
      },
      post: (option: {
        body: Methods44["post"]["reqBody"];
        headers: Methods44["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods44["post"]["resBody"]>(
          prefix,
          PATH41,
          POST,
          option
        ).json(),
      $post: (option: {
        body: Methods44["post"]["reqBody"];
        headers: Methods44["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods44["post"]["resBody"]>(prefix, PATH41, POST, option)
          .json()
          .then((r) => r.body),
      get: (option: {
        query: Methods44["get"]["query"] | undefined;
        headers: Methods44["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods44["get"]["resBody"]>(prefix, PATH41, GET, option).json(),
      $get: (option: {
        headers: Methods44["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods44["get"]["resBody"]>(prefix, PATH41, GET, option)
          .json()
          .then((r) => r.body),
      getEditInfo: (option: {
        query: Methods44["get"]["query"] | undefined;
        headers: Methods44["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods44["get"]["resBody"]>(
          prefix,
          PATH59,
          GET,
          option
        ).json(),
      $getEditInfo: (option: {
        headers: Methods44["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods44["get"]["resBody"]>(prefix, PATH59, GET, option)
          .json()
          .then((r) => r.body),
      delete: (option: {
        query: Methods44["delete"]["query"] | undefined;
        headers: Methods44["delete"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods44["delete"]["resBody"]>(
          prefix,
          PATH41,
          DELETE,
          option
        ).json(),
      $delete: (option: {
        headers: Methods44["delete"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods44["delete"]["resBody"]>(prefix, PATH41, DELETE, option)
          .json()
          .then((r) => r.body),
      put: (option: {
        body: Methods44["put"]["reqBody"] | undefined;
        headers: Methods44["put"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods44["put"]["resBody"]>(prefix, PATH41, PUT, option).json(),
      $put: (option: {
        body: Methods44["put"]["reqBody"] | undefined;
        headers: Methods44["put"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods44["put"]["resBody"]>(prefix, PATH41, PUT, option)
          .json()
          .then((r) => r.body),
      $path: () => `${prefix}${PATH41}`,
    },
    image: {
      post: (option: {
        body: Methods46["post"]["reqBody"];
        headers: Methods46["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods46["post"]["resBody"]>(
          prefix,
          PATH43,
          POST,
          option
        ).json(),
      $post: (option: {
        body: Methods46["post"]["reqBody"];
        headers: Methods46["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods46["post"]["resBody"]>(prefix, PATH43, POST, option)
          .json()
          .then((r) => r.body),
      delete: (option: {
        body: Methods46["delete"]["reqBody"];
        headers: Methods46["delete"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods46["delete"]["resBody"]>(
          prefix,
          PATH43,
          DELETE,
          option
        ).json(),
      $delete: (option: {
        body: Methods46["delete"]["reqBody"];
        headers: Methods46["delete"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods46["delete"]["resBody"]>(prefix, PATH43, DELETE, option)
          .json()
          .then((r) => r.body),
    },
    board_categories: {
      list_categories_forum_page: {
        get: (option: {
        headers?: Methods55["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods55["get"]["resBody"]>(prefix, PATH55, GET, option).json(),
      $get: (option: {
        headers: Methods55["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods55["get"]["resBody"]>(prefix, PATH55, GET, option)
          .json()
          .then((r) => r.body),
        $path: () => `${prefix}${PATH55}`
      },
      _id: (category_id: number) => {
        const prefixBoardCategoryDetail = `${PATH42}/${category_id}`;
        const prefixBoardList = `${PATH42}/${category_id}/boards`
        return {
          boards: () => {
            return {
              get: (option: {
                query: Methods57["get"]["query"];
                headers: Methods57["get"]["reqHeaders"];
                config?: T | undefined;
              }) =>
                fetch<Methods57["get"]["resBody"]>(
                  prefix,
                  prefixBoardList,
                  GET,
                  option
                ).json(),
              $get: (option: {
                query: Methods57["get"]["query"];
                headers: Methods57["get"]["reqHeaders"];
                config?: T | undefined;
              }) =>
                fetch<Methods57["get"]["resBody"]>(prefix, prefixBoardList, GET, option)
                  .json()
                  .then((r) => r.body),
              $path: () => `${prefix}${prefixBoardList}`,
            };
          },
          get: (option: {
            headers: Methods56["get"]["reqHeaders"];
            config?: T | undefined;
          }) =>
            fetch<Methods56["get"]["resBody"]>(
              prefix,
              prefixBoardCategoryDetail,
              GET,
              option
            ).json(),
          $get: (option: {
            headers: Methods56["get"]["reqHeaders"];
            config?: T | undefined;
          }) =>
            fetch<Methods56["get"]["resBody"]>(prefix, prefixBoardCategoryDetail, GET, option)
              .json()
              .then((r) => r.body),
          $path: () => `${prefix}${prefixBoardCategoryDetail}`,
        };
      },
      get: (option: {
        headers?: Methods45["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods45["get"]["resBody"]>(prefix, PATH42, GET, option).json(),
      $get: (option: {
        headers: Methods45["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods45["get"]["resBody"]>(prefix, PATH42, GET, option)
          .json()
          .then((r) => r.body),
      $path: () => `${prefix}${PATH42}`,
    },
    ng_words: {
      get: (option: {
        headers?: Methods47["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods47["get"]["resBody"]>(prefix, PATH44, GET, option).json(),
      $get: (option: {
        headers: Methods47["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods47["get"]["resBody"]>(prefix, PATH44, GET, option)
          .json()
          .then((r) => r.body),
      $path: () => `${prefix}${PATH44}`,
    },
    board_likes: {
      get: (option: {
        query?: Methods48["get"]["query"] | undefined;
        headers?: Methods48["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods48["get"]["resBody"]>(prefix, PATH45, GET, option).json(),
      $get: (option: {
        headers: Methods48["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods48["get"]["resBody"]>(prefix, PATH45, GET, option)
          .json()
          .then((r) => r.body),
      $path: () => `${prefix}${PATH45}`,
      post: (option: {
        body: Methods48["post"]["reqBody"];
        headers: Methods48["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods48["post"]["resBody"]>(
          prefix,
          PATH47,
          POST,
          option
        ).json(),
      $post: (option: {
        body: Methods48["post"]["reqBody"];
        headers: Methods48["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods48["post"]["resBody"]>(prefix, PATH47, POST, option)
          .json()
          .then((r) => r.body),
    },
    board_view: {
      post: (option: {
        body: Methods49["post"]["reqBody"];
        headers: Methods49["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods49["post"]["resBody"]>(
          prefix,
          PATH48,
          POST,
          option
        ).json(),
      $post: (option: {
        body: Methods49["post"]["reqBody"];
        headers: Methods49["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods49["post"]["resBody"]>(prefix, PATH48, POST, option)
          .json()
          .then((r) => r.body),
      $path: () => `${prefix}${PATH48}`,
    },
    board_comment: {
      report: {
        put: (option: {
          body: Methods52["put"]["reqBody"] | undefined;
          headers: Methods52["put"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods52["put"]["resBody"]>(
            prefix,
            PATH50,
            PUT,
            option
          ).json(),
        $put: (option: {
          body: Methods52["put"]["reqBody"] | undefined;
          headers: Methods52["put"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods52["put"]["resBody"]>(prefix, PATH50, PUT, option)
            .json()
            .then((r) => r.body),
      },
      pinned: {
        put: (option: {
          body: Methods53["put"]["reqBody"] | undefined;
          headers: Methods53["put"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods53["put"]["resBody"]>(
            prefix,
            PATH51,
            PUT,
            option
          ).json(),
        $put: (option: {
          body: Methods53["put"]["reqBody"] | undefined;
          headers: Methods53["put"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods53["put"]["resBody"]>(prefix, PATH51, PUT, option)
            .json()
            .then((r) => r.body),
      },
      get: (option: {
        query?: Methods51["get"]["query"] | undefined;
        headers?: Methods51["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods51["get"]["resBody"]>(prefix, PATH49, GET, option).json(),
      $get: (option: {
        headers: Methods51["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods51["get"]["resBody"]>(prefix, PATH49, GET, option)
          .json()
          .then((r) => r.body),
      getMyComments: (option: {
        query?: Methods51["getMyComments"]["query"] | undefined;
        headers?: Methods51["getMyComments"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods51["getMyComments"]["resBody"]>(prefix, PATH58, GET, option).json(),
      $getMyComments: (option: {
        headers: Methods51["getMyComments"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods51["getMyComments"]["resBody"]>(prefix, PATH58, GET, option)
          .json()
          .then((r) => r.body),
      post: (option: {
        body: Methods51["post"]["reqBody"];
        headers: Methods51["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods51["post"]["resBody"]>(
          prefix,
          PATH49,
          POST,
          option
        ).json(),
      $post: (option: {
        body: Methods51["post"]["reqBody"];
        headers: Methods51["post"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods51["post"]["resBody"]>(prefix, PATH49, POST, option)
          .json()
          .then((r) => r.body),
      delete: (option: {
        query: Methods51["delete"]["query"] | undefined;
        headers: Methods51["delete"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods51["delete"]["resBody"]>(
          prefix,
          PATH49,
          DELETE,
          option
        ).json(),
      $delete: (option: {
        headers: Methods51["delete"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods51["delete"]["resBody"]>(prefix, PATH49, DELETE, option)
          .json()
          .then((r) => r.body),
      put: (option: {
        body: Methods51["put"]["reqBody"] | undefined;
        headers: Methods51["put"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods51["put"]["resBody"]>(prefix, PATH49, PUT, option).json(),
      $put: (option: {
        body: Methods51["put"]["reqBody"] | undefined;
        headers: Methods51["put"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods51["put"]["resBody"]>(prefix, PATH49, PUT, option)
          .json()
          .then((r) => r.body),
      $path: () => `${prefix}${PATH49}`,
    },
    recent: {
      get: (option: {
        headers: Methods44["getRecent"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods44["getRecent"]["resBody"]>(
          prefix,
          PATH52,
          GET,
          option
        ).json(),
      $get: (option: {
        headers: Methods44["getRecent"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods44["getRecent"]["resBody"]>(prefix, PATH52, GET, option)
          .json()
          .then((r) => r.body),
    },
    myBoards: {
      get: (option: {
        query?: Methods44["getMyBoards"]["query"] | undefined;
        headers: Methods44["getMyBoards"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods44["getMyBoards"]["resBody"]>(
          prefix,
          PATH56,
          GET,
          option
        ).json(),
      $get: (option: {
        headers: Methods44["getMyBoards"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods44["getMyBoards"]["resBody"]>(prefix, PATH56, GET, option)
          .json()
          .then((r) => r.body),
    },
    myActivityBoards: {
      get: (option: {
        query?: Methods44["getMyActivityBoards"]["query"] | undefined;
        headers: Methods44["getMyActivityBoards"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods44["getMyActivityBoards"]["resBody"]>(
          prefix,
          PATH57,
          GET,
          option
        ).json(),
      $get: (option: {
        headers: Methods44["getMyActivityBoards"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods44["getMyActivityBoards"]["resBody"]>(prefix, PATH57, GET, option)
          .json()
          .then((r) => r.body),
    },
    notifications: {
      mark_as_read: {
        put: (option: {
          headers: Methods54["put"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods54["put"]["resBody"]>(
            prefix,
            PATH54,
            PUT,
            option
          ).json(),
        $put: (option: {
          headers: Methods54["put"]["reqHeaders"];
          config?: T | undefined;
        }) =>
          fetch<Methods54["put"]["resBody"]>(prefix, PATH54, PUT, option)
            .json()
            .then((r) => r.body),
      },
      get: (option: {
        query?: Methods54["get"]["query"] | undefined;
        headers?: Methods54["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods54["get"]["resBody"]>(prefix, PATH53, GET, option).json(),
      $get: (option: {
        query?: Methods54["get"]["query"] | undefined;
        headers: Methods54["get"]["reqHeaders"];
        config?: T | undefined;
      }) =>
        fetch<Methods54["get"]["resBody"]>(prefix, PATH53, GET, option)
          .json()
          .then((r) => r.body),
      $path: () => `${prefix}${PATH53}`,
    },
  };
};

export type ApiInstance = ReturnType<typeof api>;
export default api;
